module.exports = __webpack_public_path__ + "static/logo-wht.a1c93f19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-wht.png
// module id = 215
// module chunks = 7203239478734 27447698812214 34471704633725 114276838955818 173894859265406